import {  BaseTLTableComponent, AxiosResponse, NotificationSendService, NotificationSendFilter, BaseTLTableBase, tlISODateTimeToLocalNoSecondsString } from "../../../Infrastructure/CorBase/CoreBase";

export default abstract class NotificationSendListBase extends BaseTLTableComponent {

	protected selectedNotificationSendId: number = 0;

	protected notificationSendService: NotificationSendService = new NotificationSendService();

	protected callActionClick() {
		this.isBusy = true;
		this.notificationSendService.delete(this.itemsSelected).then(() => this.fetchData()).catch(error => {
			var errorMessage = this.$t('notificationSend.errorMessage').toString();
			super.showAlertModalWithErrorMessageList(errorMessage);
			this.isBusy = false;
		});
		this.itemsSelected = null;
		(this.$refs.notificationSendsTable as BaseTLTableBase).clearSelected();
	}

	public sendAgainBase(items: any) {
		this.isBusy = true;
		this.notificationSendService.sendAgain(items).then(res => {
			
			//if (res.status == 204) {
			//	(this.$refs.notificationSendTable as BaseTLTableBase).clearSelected();
			//	this.fetchData();
			//}
			this.isBusy = false;
			if (res.data.isSuccess) {
				this.showAlertModalWithTitleAndContent(this.$t('global.messageInfo').toString(), this.$t('notificationSend.messageSendAgain').toString());				
			}
			else {
				super.showAlertModalWithErrorMessageList(res.data.errorMessage);
			}
			(this.$refs.notificationSendTable as BaseTLTableBase).clearSelected();
			this.fetchData();
		}).catch((error) => {
			this.isBusy = false;
			super.showAlertModalWithErrorMessageList(error);
		});
	}

	protected contentModal = this.$t('notificationSend.messageQuestionMain').toString();
	protected showAlertBeforeDeleteBase(itemsSelected: any) {
		
		var idNotificationSend = Number(itemsSelected);
		this.notificationSendService.getById(idNotificationSend).then(res => {
			var content = this.$t('notificationSend.messageQuestionMain').toString();
			if (res.data.corUserNotificationSendCount > 0) {
				content = this.$t('notificationSend.messageQuestionDelete1').toString() + res.data.corUserNotificationSendCount +
					this.$t('notificationSend.messageQuestionDelete2').toString() + content;
			}
			this.contentModal = content;
			this.showAlertBeforeActionClickBase(itemsSelected, content);
		});		
	}

	goToStudentBase(item: any) {
		this.$router.push({
			name: 'StudentDetail'
			, params: {
				id: item.person.id.toString(), goBack: "NotificationSendList"
			}
			, query: {
				id: item.person.id.toString(), goBack: "NotificationSendList"
			}
		});
	}

	protected setFields() {
		this.fields = [
			//{ key: 'id', label: this.$t('notificationSend.fieldIdentif'), trans: 'notificationSend.fieldIdentif', sortable: true, class: 'text-center' },
			{ key: 'subjectText', label: this.$t('notificationSend.fieldSubject'), trans: 'notificationSend.fieldSubject', sortable: true, class: 'text-left', tooltip: 'subjectTextTooltip', design: 'tooltip', minLengthToShowTooltip: 1 },
			//{ key: 'idPersonNavigation', label: this.$t('notificationSend.fieldPerson'), trans: 'notificationSend.fieldPerson', sortable: true, class: 'text-left', design: 'goDetailId' },
			{ key: 'sendDate', label: this.$t('notificationSend.fieldDateSend'), trans: 'notificationSend.fieldDateSend', sortable: true, class: 'text-left', formatter: (x: Date) => tlISODateTimeToLocalNoSecondsString(x) },

			//{ key: 'sendDate', label: this.$t('notificationSend.fieldDateSend'), trans: 'notificationSend.fieldDateSend', sortable: true, class: 'text-left' },
			{ key: 'sendStatus', label: this.$t('notificationSend.fieldState'), trans: 'notificationSend.fieldState', sortable: true, class: 'text-left' },
			{ key: 'sendAddress', label: this.$t('notificationSend.fieldAddress'), trans: 'notificationSend.fieldAddress', sortable: true, class: 'text-left', tooltip: 'sendAddressTooltip', design: 'tooltip', minLengthToShowTooltip: 1 },
			
			{ key: 'actions', label: this.$t('notificationSend.fieldAction'), trans: 'notificationSend.fieldAction', class: 'text-right' }
		]
	};

	//TODO nefunguje filtr od do
	protected setfilters(value: any) {
		if (value != null) {
			this.filters = value;
		}
		else {
			this.filters = [
				{ key: 'subjectText', label: this.$t('notificationSend.fieldSubject'), trans: 'notificationSend.fieldSubject', selected: false, value: null, type: 'text' },
				{ key: 'idPersonNavigation', label: this.$t('notificationSend.fieldPerson'), trans: 'notificationSend.fieldPerson', selected: false, value: null, type: 'text' },
		//		{ key: 'sendDate', label: this.$t('notificationSend.fieldDateSend'), trans: 'notificationSend.fieldDateSend', selected: false, value: null, type: 'text' },
				{ key: 'sendAddress', label: this.$t('notificationSend.fieldAddress'), trans: 'notificationSend.fieldAddress', selected: false, value: null, type: 'text' },
				{ key: 'sendDateFrom', label: this.$t('notificationSend.fieldDateSendFrom'), trans: 'notificationSend.fieldDateSendFrom', selected: false, value: null, type: 'datetime', moreThan: true, refItem: 'sendDate' },
				{ key: 'sendDateTo', label: this.$t('notificationSend.fieldDateSendTo'), trans: 'notificationSend.fieldDateSendTo', selected: false, value: null, type: 'datetime', moreThan: false, refItem: 'sendDate' },

		];
		}
	}

	//protected created() {
	//	super.initializeRights('COR_NotificationSend_Create', 'COR_NotificationSend_Delete', 'COR_NotificationSend_Read', 'COR_NotificationSend_Update');
	//	super.created();
	//	super.setDetailName('NotificationSendDetail');
	//	//this.fetchData();	
	//};

	protected fetchData() {
		super.fetchData();
	}

	protected fetchDataFromServer(): Promise<AxiosResponse<any>> {
		let notificationSendFilter: NotificationSendFilter = new NotificationSendFilter(this.$store.state.idPerson, this.$store.state.idTenant);
		return this.notificationSendService.getAllByFilter(notificationSendFilter);
	}

	//zat�m nepotrebujeme
	fetchRefreshDataFromServer(): Promise<AxiosResponse<any>> {
		return this.fetchDataFromServer();
	}

	refreshItems(items: any[], refreshData: any[]) {
		return items;
	}

	protected prepareItems(items: any[]) {
		for (var i = 0; i < items.length; i++) {
			items[i].sendDate = tlISODateTimeToLocalNoSecondsString(items[i].sendDate);
			items[i].sendDateFrom = items[i].sendDate;
			items[i].sendDateTo = items[i].sendDate;
		}}
};